/**
 * Amplify's Authenticator in Finnish: Amplify ships no Finnish dictionary. `auth.test.ts` compares the
 * keys with Amplify's own lists, so a text Amplify adds fails there until it is translated or listed
 * as one this login never shows.
 */
export const fiAuthenticationDict = {
  'Account recovery requires verified contact information': 'Tilin palauttaminen vaatii vahvistetun yhteystiedon',
  'Back to Sign In': 'Takaisin kirjautumiseen',
  'Change Password': 'Vaihda salasana',
  Changing: 'Vaihdetaan',
  Code: 'Koodi',
  'Code *': 'Sähköpostiisi lähetetty koodi',
  Confirm: 'Vahvista',
  'Confirm Password': 'Salasana uudelleen',
  'Confirm Sign Up': 'Vahvista rekisteröityminen',
  'Confirmation Code': 'Vahvistuskoodi',
  Confirming: 'Vahvistetaan',
  'Create Account': 'Rekisteröidy',
  'Create a new account': 'Rekisteröidy',
  'Creating Account': 'Rekisteröidään',
  'Dismiss alert': 'Sulje ilmoitus',
  Email: 'Sähköposti',
  'Enter your Confirmation Code': 'Kirjoita vahvistuskoodisi',
  'Enter your code': 'Kirjoita vahvistuskoodisi',
  'Enter your Email': 'Kirjoita sähköpostiosoitteesi',
  'Enter your email': 'Kirjoita sähköpostiosoitteesi',
  'Enter your Password': 'Kirjoita haluamasi salasana',
  'Forgot Password?': 'Unohditko salasanasi?',
  'Forgot password?': 'Unohditko salasanasi?',
  'Forgot your password?': 'Unohditko salasanasi?',
  'Hide password': 'Piilota salasana',
  'Invalid verification code provided, please try again.': 'Virheellinen koodi, yritä uudelleen.',
  'It may take a minute to arrive': 'Sen saapumisessa voi kestää hetki',
  Loading: 'Ladataan',
  'New Password': 'Uusi salasana',
  'New password': 'Uusi salasana',
  or: 'tai',
  Password: 'Salasana',
  'Password is hidden': 'Salasana on piilotettu',
  'Password is shown': 'Salasana näkyy',
  'Password must have at least 8 characters': 'Salasanassa on oltava vähintään 8 merkkiä',
  'Password must have lower case letters': 'Salasanassa on oltava pieniä kirjaimia',
  'Password must have numbers': 'Salasanassa on oltava numeroita',
  'Password must have upper case letters': 'Salasanassa on oltava isoja kirjaimia',
  'Please confirm your Password': 'Kirjoita haluamasi salasanasi uudelleen',
  'Resend Code': 'Lähetä uusi koodi sähköpostiin',
  'Reset Password': 'Vaihda salasana',
  'Reset your Password': 'Vaihda salasana',
  'Reset your password': 'Vaihda salasana',
  'Send Code': 'Lähetä koodi sähköpostiin',
  'Send code': 'Lähetä koodi sähköpostiin',
  Sending: 'Lähetetään',
  'Show password': 'Näytä salasana',
  'Sign In': 'Kirjaudu',
  'Sign In with Google': 'Kirjaudu Google-tilillä',
  'Sign in': 'Kirjaudu',
  'Sign in to your account': 'Kirjaudu sisään',
  'Sign Up with Google': 'Rekisteröidy Google-tilillä',
  'Signing in': 'Kirjaudutaan',
  Skip: 'Ohita',
  Submit: 'Lähetä',
  Submitting: 'Lähetetään',
  Verify: 'Vahvista',
  'Verify Contact': 'Vahvista yhteystieto',
  'We Emailed You': 'Lähetimme sinulle sähköpostia',
  // Amplify heads the sign-up confirmation with this when it does not know how the code went out (an SMS
  // gets 'We Sent A Code'). The user pool sends no SMS, so the Finnish names no channel.
  'We Texted You': 'Lähetimme sinulle koodin',
  // Amplify follows these with the address, a full stop and 'It may take a minute to arrive.'
  'Your code is on the way. To log in, enter the code we emailed to':
    'Koodi on matkalla. Kirjaudu sisään syöttämällä koodi, jonka lähetimme osoitteeseen',
  'Your code is on the way. To log in, enter the code we sent you':
    'Koodi on matkalla. Kirjaudu sisään syöttämällä koodi, jonka lähetimme sinulle',
  'Your passwords must match': 'Salasanat eivät täsmää',
}
